import React, { Component } from 'react';
//import { UnableToSignIn } from '../UnableToSignIn';
import { Button } from "react-bootstrap";
import { t } from "../helper/ClientAppLocalizer"

export class ChooseMethod extends Component {
    render (){
        return (
            <div className="row-footer">
                {/*<Button id="loginAnotherWay" variant="link" style={{ color: '#08c', paddingRight: 15, borderRight: "1px solid #909090", borderRadius: 0, fontSize: 14, textAlign: "center", fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif' }} onClick={this.props.changeVerificationMethod}>*/}
                <Button id="loginAnotherWay" variant="link" style={{ color: '#08c', paddingRight: 15,borderRadius: 0, fontSize: 12, textAlign: "center", fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif' }} onClick={this.props.changeVerificationMethod}>
                    {t("LoginAnotherWay")}
                </Button>
                {/*<UnableToSignIn lockoutMessage={this.props.lockoutMessage} />*/}
            </div>
        );
    }
}